// extracted by mini-css-extract-plugin
export default {"iconDefault":"ExpenseCategory_iconDefault__OfAZS"};